import { api } from "./client";

export type PremiumTier = {
  id: "monthly" | "quarterly" | "yearly";
  days: number;
  stars: number;
  title: string;
  description: string;
  discountPercent?: number;
};

export type PremiumStatus = {
  active: boolean;
  premium_until: string | null;
  tiers: PremiumTier[];
};

export async function getPremium(): Promise<PremiumStatus> {
  return api<PremiumStatus>("/api/premium");
}

export async function createPremiumInvoice(tier: PremiumTier["id"]): Promise<{ url: string }> {
  return api<{ url: string }>("/api/premium/invoice", {
    method: "POST",
    body: JSON.stringify({ tier }),
  });
}
